export const Constants = {
	appGuideUrl: 'https://static.vionice.io/public-assets/guides/roadai-app/roadai_app_guide_en.pdf',
	mapGuideUrl: 'https://static.vionice.io/public-assets/guides/roadai-map/roadai_map_guide_en.pdf',
	dataCollectionGuideUrl: 'https://static.vionice.io/public-assets/guides/roadai-app/roadai_mobile_data_guidelines_en.pdf'
};
